import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import earnings from '@/components/earnings'
import guardian_me from '@/components/guardian_me'
import returns_detailed from '@/components/returns_detailed'
import to_report from '@/components/to_report'
import basic_information from '@/components/basic_information'
import personals_conditions from '@/components/personals_conditions'
import my_guardian from '@/components/my_guardian'
import edit_information from '@/components/edit_information'
import like from '@/components/like'
import comments from '@/components/comments'
import system_message from '@/components/system_message'
import agreement from '@/components/agreement'
import exchange from '@/components/exchange'
import guardian from '@/components/guardian'
import withdrawal from '@/components/withdrawal'
import yuelao from '@/components/yuelao'
import add_bank from '@/components/add_bank'
import invited_share from '@/components/invited_share'
import invited_share_user from '@/components/invited_share_user'
import blind_date_record from '@/components/blind_date_record'
import feedback from '@/components/feedback'
import more_information from '@/components/more_information'
import vip from '@/components/vip'
import consumption_log from '@/components/consumption_log'
import search from '@/components/search'
import shopAdd from '@/components/shop_add'
import shopManage from '@/components/shop_manage'
import shopList from '@/components/shop_product_list'
import myShop from '@/components/my_shop'
import createShop from '@/components/create_shop'
import visitor from '@/components/visitor'
import download from '@/components/download'
import room_recording from '@/components/room_recording'


Vue.use(Router)
export default new Router({
  mode: 'history',
	routes: [
		{
			path: '/Index',
			name: 'Index',
			component: Index,
			meta: {
				title: '充值'
			  }
		},
    {
      path: '/blind_date_record',
      name: 'blind_date_record',
      component: blind_date_record,
      meta: {
        title: '相亲记录'
      }
    },
    {
      path: '/exchange',
      name: 'exchange',
      component: exchange,
      meta: {
        title: '兑换'
      }
    },
		{
			path: '/like',
			name: 'like',
			component: like,
			meta: {
				title: '喜欢'
			  }
		},
		{
			path: '/comments',
			name: 'comments',
			component: comments,
			meta: {
				title: '评论'
			  }
		},
		{
			path: '/system_message',
			name: 'system_message',
			component: system_message,
			meta: {
				title: '系统消息'
			  }
		},
		{
			path: '/guardian',
			name: 'guardian',
			component: guardian,
			meta: {
				title: '我守护的列表xxxxx'
			  }
		},
		{
			path: '/my_guardian',
			name: 'my_guardian',
			component: my_guardian,
			meta: {
				title: '我要守护他xxxxxx'
			  }
		},
		{
			path: '/returns_detailed',
			name: 'returns_detailed',
			component: returns_detailed,
			meta: {
				title: '收益明细'
			  }
		},
    {
      path: '/consumption_log',
      name: 'consumption_log',
      component: consumption_log,
      meta: {
        title: '消费记录'
      }
    },
		{
			path: '/edit_information',
			name: 'edit_information',
			component: edit_information,
			meta: {
				title: '完善资料'
			  }
		},
		{
			path: '/basic_information',
			name: 'basic_information',
			component: basic_information,
			meta: {
				title: '基本资料'
			  }
		},
    {
      path: '/more_information',
      name: 'more_information',
      component: more_information,
      meta: {
        title: '更多资料'
      }
    },
		{
			path: '/earnings',
			name: 'earnings',
			component: earnings,
			meta: {
				title: '收益'
			  }
		},
		{
			path: '/yuelao',
			name: 'yuelao',
			component: yuelao,
			meta: {
				title: '成为红娘月老'
			  }
		},
    {
      path: '/withdrawal',
      name: 'withdrawal',
      component: withdrawal,
      meta: {
        title: '提现'
      }
    },
		{
			path: '/personals_conditions',
			name: 'personals_conditions',
			component: personals_conditions,
			meta: {
				title: '征友条件'
			  }
		},
		{
			path: '/to_report',
			name: 'to_report',
			component: to_report,
			meta: {
				title: '举报中心'
			  }
		},
		{
			path: '/guardian_me',
			name: 'guardian_me',
			component: guardian_me,
			meta: {
				title: '守护我的 xxxxx'
			  }
		},
    {
      path: '/agreement',
      name: 'agreement',
      component: agreement,
      meta: {
        title: '充值协议'
      }
    },
    {
      path: '/add_bank',
      name: 'add_bank',
      component: add_bank,
      meta: {
        title: '添加银行卡'
      }
    },
    {
      path: '/invited_share',
      name: 'invited_share',
      component: invited_share,
      meta: {
        title: '分享赚钱'
      }
    },
    {
      path: '/invited_share_user',
      name: 'invited_share_user',
      component: invited_share_user,
      meta: {
        title: '邀请的用户'
      }
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: feedback,
      meta: {
        title: '意见反馈'
      }
    },
    {
      path: '/vip',
      name: 'vip',
      component: vip,
      meta: {
        title: '购买会员'
      }
    },
    {
      path: '/search',
      name: 'search',
      component: search,
      meta: {
        title: '筛选'
      }
    },
    {
      path: '/shopAdd',
      name: 'shopAdd',
      component: shopAdd,
      meta: {
        title: '添加商品'
      }
    },
    {
      path: '/shopManage',
      name: 'shopManage',
      component: shopManage,
      meta: {
        title: '店铺管理'
      }
    },
    {
      path: '/shopList',
      name: 'shopList',
      component: shopList,
      meta: {
        title: '商品列表'
      }
    },
    {
      path: '/myShop',
      name: 'myShop',
      component: myShop,
      meta: {
        title: '开通小店'
      }
    },
    {
      path: '/createShop',
      name: 'createShop',
      component: createShop,
      meta: {
        title: '创建店铺'
      }
    },
    {
      path: '/visitor',
      name: 'visitor',
      component: visitor,
      meta: {
        title: '最近访客'
      }
    },
    {
      path: '/id/:id',
      component: download,
      meta: {
        title: '下载APP'
      }
    },
    {
      path: '/room_recording',
      name: 'room_recording',
      component: room_recording,
      meta: {
        title: '选择回放'
      }
    },
	],

})



// WEBPACK FOOTER //
// ./src/router/index.js